import type { AdminUser } from "./types.ts";

export function firstSellerEmail(usersData: unknown): string {
  if (!Array.isArray(usersData)) return "";
  const seller = usersData.find((user) => user && typeof user === "object" && (user as AdminUser).role !== "admin") as AdminUser | undefined;
  return seller?.email || "";
}

export function formatNumber(value?: number) {
  return Number(value || 0).toLocaleString("pt-BR");
}

export function formatPercent(value?: number) {
  return `${formatNumber(value)}%`;
}

export function formatDate(value?: string | null) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }).format(date);
}
